import {BasicButton} from '@packages/ui';
import type React from 'react';
import type {
  RecruitmentDetailSchedule,
  RecruitmentTag as RecruitmentTagType,
} from '../../../../../core/entities/recruitment/schema';
import {CommonLink} from '../../../../../shared/components/CommonLink';
import {Schedules} from '../../../../recruitingInfo/components/Container/Presenter/Schedules';
import {
  type RecruitmentType,
  Tags,
} from '../../../../recruitingInfo/components/Container/Presenter/Tags';
import {UpdatedBy} from './UpdatedAt';

type Props = {
  title: string;
  recruitmentType: RecruitmentType;
  targetYear: number;
  groupedJobTypes: Array<{id: number; name: string}>;
  tags: RecruitmentTagType[];
  entryURL?: string;
  schedules?: RecruitmentDetailSchedule[];
  modifiedAt: string;
};

export const RecruitmentHeaderPC: React.FC<Props> = ({
  title,
  recruitmentType,
  targetYear,
  groupedJobTypes,
  tags,
  entryURL,
  schedules,
  modifiedAt,
}) => {
  return (
    <div className="flex flex-col bg-white p-24 rounded-16 w-[814px] gap-24">
      <div className="flex flex-col">
        <h1 className="leading font-bold text-xl">{title}</h1>
        <div className="flex justify-start items-start flex-wrap mb-4">
          <Tags
            tags={tags}
            type={recruitmentType}
            targetYear={targetYear}
            groupedJobTypes={groupedJobTypes}
            size="sm"
            isGrayColor
          />
        </div>
        <div className="flex justify-between gap-8">
          <UpdatedBy updatedAt={modifiedAt} />
          {entryURL && (
            <div className="flex justify-end flex-wrap mb-4">
              <CommonLink
                href={entryURL}
                target="_blank"
                rel="noopener noreferrer"
                id="recruiting_info_entry_button"
              >
                <BasicButton
                  label="エントリー"
                  className="px-24 py-8 bg-gradient-to-r from-error to-sub text-sm font-bold rounded-[8px] hover:opacity-80"
                  isPrimary={false}
                  isLarge={false}
                  isDisabled={false}
                />
              </CommonLink>
            </div>
          )}
        </div>
      </div>
      {schedules && schedules.length > 0 && (
        <div className="flex flex-col gap-8">
          <Schedules schedules={schedules} withCalendar withRegisterButton />
        </div>
      )}
    </div>
  );
};
